module.exports = "<th>Статус помещения</th>\n<td>\n  <div class=\"filter__button-group\">\n    <term\n      source=\"source.only_flat\"\n      behavior=\"checkbox\"\n      text=\"Без апартаментов\"\n      on-change=\"advancedPopup.updateOnlyFlat()\"/>\n\n    <term\n      source=\"source.apartment\"\n      behavior=\"checkbox\"\n      text=\"Только апартаменты\"\n      on-change=\"advancedPopup.updateApartments()\"/>\n\n    <term\n      source=\"source.penthouse\"\n      behavior=\"checkbox\"\n      text=\"Пентхаус\"/>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/apartment.html
// module id = 311
// module chunks = 0